import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextField, Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const FormContainer = styled(Box)(({ theme, isRtl }) => ({
  // maxWidth: '800px',
  // margin: '0 auto',
  padding: '40px 20px',
  direction: isRtl ? 'rtl' : 'ltr',
  textAlign: isRtl ? 'right' : 'left',
  // background: 'linear-gradient(135deg, rgba(240, 248, 255, 0.8) 0%, rgba(255, 255, 255, 0.9) 100%)',
  borderRadius: '12px',
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
  // backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.2)',
  // position: 'relative',
  // '&::before': {
  //   content: '""',
  //   position: 'absolute',
  //   top: 0,
  //   left: 0,
  //   right: 0,
  //   bottom: 0,
  //   backgroundImage: 'radial-gradient(circle at 25% 25%, rgba(173, 216, 230, 0.1) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(135, 206, 235, 0.1) 0%, transparent 50%)',
  //   borderRadius: '12px',
  //   zIndex: -1
  // }
}));

const FormGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '20px',
  marginBottom: '20px',
  [theme.breakpoints.down('sm')]: {
    gridTemplateColumns: '1fr'
  }
}));

const ContactForm = () => {
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    tel: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const emailBody = `
      Name: ${formData.name}
      Email: ${formData.email}
      Phone: ${formData.tel}
      Company: ${formData.company}
      Message: ${formData.message}
    `.trim();

    const mailtoUrl = `mailto:info@Alrabiegroup.com?subject=Contact Form Inquiry from ${formData.name}&body=${encodeURIComponent(emailBody)}`;
    
    window.open(mailtoUrl);
  };

  const isRtl = i18n.language === 'ar';

  return (
    <FormContainer isRtl={isRtl}>
      <Typography
        variant="body1"
        sx={{
          color: '#333',
          marginBottom: '30px',
          fontSize: '16px',
          lineHeight: 1.6,
          // fontFamily: isRtl ? 'Arial, sans-serif' : 'inherit'
        }}
      >
        {t('contactForm.intro')}
      </Typography>

      <form onSubmit={handleSubmit}>
        <FormGrid>
          <Box>
            <TextField
              fullWidth
              name="name"
              placeholder={t('contactForm.name')}
              value={formData.name}
              onChange={handleChange}
              required
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#f8f9fa',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.1)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(154, 74, 32, 0.3)',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'rgb(154, 74, 32)',
                  }
                }
              }}
            />
            <Typography
              component="span"
              sx={{
                color: 'red',
                fontSize: '12px',
                marginLeft: '8px'
              }}
            >
              *
            </Typography>
          </Box>

          <Box>
            <TextField
              fullWidth
              name="email"
              type="email"
              placeholder={t('contactForm.email')}
              value={formData.email}
              onChange={handleChange}
              required
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#f8f9fa',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.1)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(154, 74, 32, 0.3)',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'rgb(154, 74, 32)',
                  }
                }
              }}
            />
            <Typography
              component="span"
              sx={{
                color: 'red',
                fontSize: '12px',
                marginLeft: '8px'
              }}
            >
              *
            </Typography>
          </Box>

          <Box>
            <TextField
              fullWidth
              name="tel"
              placeholder={t('contactForm.tel')}
              value={formData.tel}
              onChange={handleChange}
              required
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#f8f9fa',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.1)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(154, 74, 32, 0.3)',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'rgb(154, 74, 32)',
                  }
                }
              }}
            />
            <Typography
              component="span"
              sx={{
                color: 'red',
                fontSize: '12px',
                marginLeft: '8px'
              }}
            >
              *
            </Typography>
          </Box>

          <Box>
            <TextField
              fullWidth
              name="company"
              placeholder={t('contactForm.company')}
              value={formData.company}
              onChange={handleChange}
              required
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: '#f8f9fa',
                  '& fieldset': {
                    borderColor: 'rgba(0, 0, 0, 0.1)',
                  },
                  '&:hover fieldset': {
                    borderColor: 'rgba(154, 74, 32, 0.3)',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: 'rgb(154, 74, 32)',
                  }
                }
              }}
            />
            <Typography
              component="span"
              sx={{
                color: 'red',
                fontSize: '12px',
                marginLeft: '8px'
              }}
            >
              *
            </Typography>
          </Box>
        </FormGrid>

        <Box sx={{ marginBottom: '30px' }}>
          <TextField
            fullWidth
            name="message"
            multiline
            rows={4}
            placeholder={t('contactForm.message')}
            value={formData.message}
            onChange={handleChange}
            required
            sx={{
              '& .MuiOutlinedInput-root': {
                backgroundColor: '#f8f9fa',
                '& fieldset': {
                  borderColor: 'rgba(0, 0, 0, 0.1)',
                },
                '&:hover fieldset': {
                  borderColor: 'rgba(154, 74, 32, 0.3)',
                },
                '&.Mui-focused fieldset': {
                  borderColor: 'rgb(154, 74, 32)',
                }
              }
            }}
          />
        </Box>

        <Box sx={{ textAlign: 'center' }}>
          <Button
            type="submit"
            variant="contained"
            size="large"
            sx={{
              backgroundColor: 'rgb(154, 74, 32)',
              color: 'white',
              padding: '12px 40px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 500,
              textTransform: 'none',
              '&:hover': {
                backgroundColor: 'rgb(134, 54, 12)',
                transform: 'translateY(-2px)',
                boxShadow: '0 8px 25px rgba(154, 74, 32, 0.3)'
              },
              transition: 'all 0.3s ease'
            }}
          >
            {t('contactForm.submit')}
          </Button>
        </Box>
      </form>
    </FormContainer>
  );
};

export default ContactForm; 